import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import * as Sentry from "@sentry/react";
import "./style/main.scss";
import { Provider } from "react-redux";
import { store } from "./store/store.ts";
import ReactPixel from "react-facebook-pixel";

const alwaysReport = false;

const config = {
  production: import.meta.env.PROD,
  development: import.meta.env.DEV,
  localHost:
    window.location.hostname === "localhost" ||
    window.location.hostname === process.env.DEV_HOST,
};

if ((config.production && !config.localHost) || alwaysReport) {
  Sentry.init({
    dsn: "https://a3f7174a309bb9c1513af6440ad9b4db@o1077038.ingest.sentry.io/4506024517369856",
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,

    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    integrations: [
      Sentry.replayIntegration({
        // Additional SDK configuration goes in here, for example:
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
  });

  console.log("Loading production pixel");
  ReactPixel.init("400794839645425");
} else if (config.production) {
  console.log("Loading test pixel");
  ReactPixel.init("800248445570396");
  ReactPixel.pageView();
}

/**
 * Strict mode causes the App to render twice. This is only an issue in dev mode
 * because it does some extra checks.
 */
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
);
